export const SET_FULLSCREEN = "FULLSCREEN::SET";
export const SET_FULLSCREEN_FAILED = "FULLSCREEN::SET_FAILED";
export const SET_FULLSCREEN_CHANGED = "FULLSCREEN::CHANGED";
